"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetRinnovoCobadge = exports.setCobadgeDaRinnovare = exports.setInizioFlussoCarteInScadenza = exports.concludiNegativamentePraticaAcquisto = exports.copyPanViewNexiDebit = exports.copyPanViewNexiDebitSuccess = exports.resetPanViewNexiDebit = exports.getPanViewNexiDebit = exports.startPanViewScaNexiDebit = exports.annullaAcquistoNexiDebitAcquisto = exports.verificaCGSNexiDebitAcquisto = exports.resetNexiDebitParametriAcquisto = exports.resetNexiDebitAcquisto = exports.resetControlloNexiDebitAcquisto = exports.setNexiDebitAcquistoSetConsensoResponseList = exports.setNexiDebitAcquistoSetPresaVisioneDocumentiFirma = exports.setNexiDebitAcquistoSetPresaVisioneDocumenti = exports.setNexiDebitAcquistoSetScopoPrevalente = exports.setNexiDebitAcquistoSetPersonaPoliticamenteEsposta = exports.setNexiDebitAcquistoSetProvenienzaFondi = exports.setNexiDebitAcquistoSetTae = exports.setNexiDebitAcquistoSetProfessione = exports.setNexiDebitAcquistoSetCodiceRapporto = exports.setNexiDebitAcquistoSetTipoCarta = exports.getConvenzioneNexiDebitAcquisto = exports.controlloNexiDebitAcquisto = exports.getListeAggiuntiveProfessioneNexiDebitAcquisto = exports.checkUserNexiDebitAcquisto = exports.getCarteNexiDebitInScadenza = exports.getParametriNexiDebitAcquisto = exports.resetPinViewNexiDebit = exports.getPinViewNexiDebit = exports.startPinViewScaNexiDebit = exports.esportaDettaglioMovimentoNexiDebitPDF = exports.esportaListaMovimentiNexiDebitPDF = exports.resetMovimentiNexiDebit = exports.resetNexiDebit = exports.resetFiltriNexiDebit = exports.getListaMovimentiNexiDebit = exports.setRapportoSelezionatoNexiDebit = exports.setNexiDebitSetOrdinamento = exports.setNexiDebitSetEntartaUscita = exports.setNexiDebitSetEntarteUscite = exports.setNexiDebitSetOffset = exports.setNexiDebitSetEsercente = exports.setNexiDebitSetImporto = exports.setNexiDebitSetPeriodo = exports.setNexiDebitSetDataA = exports.setNexiDebitSetDataDa = exports.getParametriNexiDebit = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_1 = require("../general");
const general_configuration_1 = require("../general/general.configuration");
const nexiDebit_types_1 = require("./nexiDebit.types");
const moment = require("moment");
function generalError(value) {
    return async (dispatch) => {
        dispatch((0, general_1.setError)(value));
    };
}
;
function getParametriNexiDebitStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PARAMETRI_START
    };
}
;
function getParametriNexiDebitSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PARAMETRI_SUCCESS,
        payload
    };
}
;
const getParametriNexiDebit = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getParametriNexiDebitStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_nexi.json')).then(response => {
            dispatch(getParametriNexiDebitSuccess((0, api_rest_1.ParametriNexiDtoFromJSON)(response)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriNexiDebit().then((response) => {
                dispatch(getParametriNexiDebitSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriNexiDebit = getParametriNexiDebit;
function setNexiDebitSetDataDa(txt) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_DATA_DA,
        payload: txt
    };
}
exports.setNexiDebitSetDataDa = setNexiDebitSetDataDa;
;
function setNexiDebitSetDataA(txt) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_DATA_A,
        payload: txt
    };
}
exports.setNexiDebitSetDataA = setNexiDebitSetDataA;
;
function setNexiDebitSetPeriodo(txt) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_PERIODO,
        payload: txt
    };
}
exports.setNexiDebitSetPeriodo = setNexiDebitSetPeriodo;
;
function setNexiDebitSetImporto(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_IMPORTO,
        payload: value
    };
}
exports.setNexiDebitSetImporto = setNexiDebitSetImporto;
;
function setNexiDebitSetEsercente(txt) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ESERCENTE,
        payload: txt
    };
}
exports.setNexiDebitSetEsercente = setNexiDebitSetEsercente;
;
function setNexiDebitSetOffset(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_OFFSET,
        payload: value
    };
}
exports.setNexiDebitSetOffset = setNexiDebitSetOffset;
;
function setNexiDebitListLoader(show) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_LIST_LOADER,
        payload: show
    };
}
;
function setNexiDebitSetEntarteUscite(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ENTRATE_USCITE,
        payload: value
    };
}
exports.setNexiDebitSetEntarteUscite = setNexiDebitSetEntarteUscite;
;
function setNexiDebitSetEntartaUscita(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ENTRATA_USCITA,
        payload: value
    };
}
exports.setNexiDebitSetEntartaUscita = setNexiDebitSetEntartaUscita;
;
function setNexiDebitSetOrdinamento(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ORDINAMENTO,
        payload: value
    };
}
exports.setNexiDebitSetOrdinamento = setNexiDebitSetOrdinamento;
;
const setRapportoSelezionatoNexiDebit = (rapporto) => {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_SET_RAPPORTO_SELEZIONATO,
        payload: rapporto
    };
};
exports.setRapportoSelezionatoNexiDebit = setRapportoSelezionatoNexiDebit;
//GET LISTA MOVIMENTI NEXI DEBIT START
function getListaMovimentiNexiDebitStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_MOVIMENTI_START
    };
}
;
function getListaMovimentiNexiDebitSuccess(payload, offset) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_MOVIMENTI_SUCCESS,
        payload,
        offset
    };
}
;
const IMPORTO_MOLTIPLICATORI_INTERVALLO = { MIN: 0.8, MAX: 1.2 };
const getListaMovimentiNexiDebit = () => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d, _e;
    const nexiDebitForm = getState().nexiDebit.form;
    if (!nexiDebitForm.offset || nexiDebitForm.offset == 0) {
        dispatch((0, general_1.setLoader)(true));
    }
    if (nexiDebitForm.offset && nexiDebitForm.offset > 0) {
        dispatch(setNexiDebitListLoader(true));
    }
    dispatch(getListaMovimentiNexiDebitStart());
    if (!nexiDebitForm.offset || nexiDebitForm.offset === 0) {
        dispatch(resetMovimentiNexiDebit());
    }
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            criteriRicercaMovimentiNexiDebitDto: {
                codiceRapporto: ((_b = (_a = nexiDebitForm.rapportoSelezionato) === null || _a === void 0 ? void 0 : _a.carta) === null || _b === void 0 ? void 0 : _b.accountId) || 0,
                binPan: ((_d = (_c = nexiDebitForm.rapportoSelezionato) === null || _c === void 0 ? void 0 : _c.carta) === null || _d === void 0 ? void 0 : _d.panBin) || '-',
                tailPan: ((_e = nexiDebitForm.rapportoSelezionato.carta) === null || _e === void 0 ? void 0 : _e.pan) || '-',
                dataIniziale: moment(nexiDebitForm.dataDa).toDate(),
                dataFinale: moment(nexiDebitForm.dataA).toDate(),
                importoDa: (0, __1.formattedNumberToNumber)(nexiDebitForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                importoA: (0, __1.formattedNumberToNumber)(nexiDebitForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                divisa: undefined,
                segno: nexiDebitForm.entrate && nexiDebitForm.uscite ? undefined : nexiDebitForm.entrate ? api_rest_1.CriteriRicercaMovimentiNexiDebitDtoSegnoEnum.A : api_rest_1.CriteriRicercaMovimentiNexiDebitDtoSegnoEnum.D,
                ordinamento: nexiDebitForm.ordinamento,
                offset: nexiDebitForm.offset,
                keyword: nexiDebitForm.esercente
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).movimentiNexiDebit(requestParameters).then((response) => {
                dispatch(getListaMovimentiNexiDebitSuccess(response, nexiDebitForm.offset));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                if (!nexiDebitForm.offset || nexiDebitForm.offset == 0) {
                    dispatch((0, general_1.setLoader)(false));
                }
                if (nexiDebitForm.offset && nexiDebitForm.offset > 0) {
                    dispatch(setNexiDebitListLoader(false));
                }
            });
        });
    }
};
exports.getListaMovimentiNexiDebit = getListaMovimentiNexiDebit;
function resetFiltriNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_FILTRO
    };
}
exports.resetFiltriNexiDebit = resetFiltriNexiDebit;
;
function resetNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET
    };
}
exports.resetNexiDebit = resetNexiDebit;
;
function resetMovimentiNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_MOVIMENTI
    };
}
exports.resetMovimentiNexiDebit = resetMovimentiNexiDebit;
;
//GET LISTA MOVIMENTI NEXI DEBIT END
//START EXPORT ELENCO MOVIMENTI PDF
function esportaListaMovimentiNexiDebitPDFStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ESPORTA_ELENCO_PDF_START
    };
}
;
function esportaListaMovimentiNexiDebitPDFSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ESPORTA_ELENCO_PDF_SUCCESS,
        payload
    };
}
;
const esportaListaMovimentiNexiDebitPDF = (share) => (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d, _e;
    const state = getState().nexiDebit;
    dispatch((0, general_1.setLoader)(true));
    //dispatch(setWaitingSection(true, `PDF${state.}`));
    dispatch(esportaListaMovimentiNexiDebitPDFStart());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const state = getState().nexiDebit;
        const nexiDebitForm = state.form;
        const esportaElencoMovimentiNexiDebitRequest = {
            type: api_rest_1.ElencoMovimentiPdfNexiDebitTypeEnum.pdf,
            criteriRicercaMovimentiNexiDebitDto: {
                codiceRapporto: ((_b = (_a = nexiDebitForm.rapportoSelezionato) === null || _a === void 0 ? void 0 : _a.carta) === null || _b === void 0 ? void 0 : _b.accountId) || 0,
                binPan: ((_d = (_c = nexiDebitForm.rapportoSelezionato) === null || _c === void 0 ? void 0 : _c.carta) === null || _d === void 0 ? void 0 : _d.panBin) || '-',
                tailPan: ((_e = nexiDebitForm.rapportoSelezionato.carta) === null || _e === void 0 ? void 0 : _e.pan) || '-',
                dataIniziale: moment(nexiDebitForm.dataDa).toDate(),
                dataFinale: moment(nexiDebitForm.dataA).toDate(),
                importoDa: (0, __1.formattedNumberToNumber)(nexiDebitForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                importoA: (0, __1.formattedNumberToNumber)(nexiDebitForm.importo) * IMPORTO_MOLTIPLICATORI_INTERVALLO.MIN || undefined,
                divisa: undefined,
                segno: nexiDebitForm.entrate && nexiDebitForm.uscite ? undefined : nexiDebitForm.entrate ? api_rest_1.CriteriRicercaMovimentiNexiDebitDtoSegnoEnum.A : api_rest_1.CriteriRicercaMovimentiNexiDebitDtoSegnoEnum.D,
                ordinamento: nexiDebitForm.ordinamento,
                offset: nexiDebitForm.offset,
                keyword: nexiDebitForm.esercente
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).elencoMovimentiPdfNexiDebit(esportaElencoMovimentiNexiDebitRequest).then(async (response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, __1.hadlePdfResponse)(response, (url) => dispatch((0, general_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, __1.download_sharePDF)(extraArguments, 'movimenti-nexi-debit.pdf', response, share);
                }
                dispatch(esportaListaMovimentiNexiDebitPDFSuccess(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
                //dispatch(setWaitingSection(false, `PDF${movimento.numeroOperazione}`));
            });
        });
    }
};
exports.esportaListaMovimentiNexiDebitPDF = esportaListaMovimentiNexiDebitPDF;
//END EXPORT ELENCO MOVIMENTI PDF
//START EXPORT DETTAGLIO MOVIMENTO PDF
function esportaDettaglioMovimentoNexiDebitPDFStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ESPORTA_DETTAGLIO_PDF_START
    };
}
;
function esportaDettaglioMovimentoNexiDebitPDFSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ESPORTA_DETTAGLIO_PDF_SUCCESS,
        payload
    };
}
;
const esportaDettaglioMovimentoNexiDebitPDF = (movimento, share) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch((0, general_1.setWaitingSection)(true, `PDF${movimento.numeroOperazione}`));
    dispatch(esportaDettaglioMovimentoNexiDebitPDFStart());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const esportaDettaglioMovimentoNexiDebitRequest = {
            movimentoNexiDebitDto: movimento
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).dettaglioMovimentiPdfNexiDebit(esportaDettaglioMovimentoNexiDebitRequest).then(async (response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, __1.hadlePdfResponse)(response, (url) => dispatch((0, general_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, __1.download_sharePDF)(extraArguments, `movimento-nexi-debit-${movimento.numeroOperazione}.pdf`, response, share);
                }
                dispatch(esportaDettaglioMovimentoNexiDebitPDFSuccess(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
                dispatch((0, general_1.setWaitingSection)(false, `PDF${movimento.numeroOperazione}`));
            });
        });
    }
};
exports.esportaDettaglioMovimentoNexiDebitPDF = esportaDettaglioMovimentoNexiDebitPDF;
//END EXPORT DETTAGLIO MOVIMENTO PDF
//START START PIN VIEW SCA
function startPinViewScaStartNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_START_PIN_VIEW__SCA_START
    };
}
;
function startPinViewScaSuccessNexiDebit(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_START_PIN_VIEW__SCA_SUCCESS,
        payload
    };
}
;
const startPinViewScaNexiDebit = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(startPinViewScaStartNexiDebit());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPinViewSCARequestDto: {
                id: cartaNexiId
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPinViewSCA(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_NEXI_DEBIT', 'GET_PIN_VIEW_SUCCESS_NEXI_DEBIT');
                dispatch(startPinViewScaSuccessNexiDebit(response));
            }).catch(async (error) => {
                extraArguments.sendEventToMatomo('PIN_VIEW_NEXI_DEBIT', `GET_PIN_VIEW_ERROR_NEXI_DEBIT ${error.message}`);
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.startPinViewScaNexiDebit = startPinViewScaNexiDebit;
//END START PIN VIEW SCA
//START GET PIN VIEW
function getPinViewStartNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PIN_VIEW_START
    };
}
;
function getPinViewSuccessNexiDebit(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PIN_VIEW_SUCCESS,
        payload
    };
}
;
const getPinViewNexiDebit = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_1.setLoader)(true));
    dispatch(getPinViewStartNexiDebit());
    if (extraArguments.mock) {
        dispatch(getPinViewSuccessNexiDebit({ "content": "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", "contentType": "image/svg+xml" }));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const nexiDebit = getState().nexiDebit;
        if (!((_a = nexiDebit.startPinViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = nexiDebit.startPinViewResponse) === null || _b === void 0 ? void 0 : _b.txId
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPinView(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPinViewSuccessNexiDebit(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getPinViewNexiDebit = getPinViewNexiDebit;
//END GET PIN VIEW
function resetPinViewNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_PIN_VIEW
    };
}
exports.resetPinViewNexiDebit = resetPinViewNexiDebit;
;
/*
to do
verifica consensi
SSO
token
*/
function getParametriNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_PARAMETRI_START
    };
}
;
function getParametriNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_PARAMETRI_SUCCESS,
        payload
    };
}
;
const getParametriNexiDebitAcquisto = (requestParams) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getParametriNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/controllo_nexi_acquisto.json')).then(response => {
            dispatch(getParametriNexiDebitAcquistoSuccess((0, api_rest_1.ParametriAcquistoNexiDebitResponseDtoFromJSON)(response)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        const request = {
            codiceRapporto: requestParams === null || requestParams === void 0 ? void 0 : requestParams.codiceRapporto,
            codiceRapportoContoCollegato: requestParams === null || requestParams === void 0 ? void 0 : requestParams.codiceRapportoContoCollegato,
            flussoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.flussoCoBadged,
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriAcquistoNexiDebit(request).then((response) => {
                dispatch(getParametriNexiDebitAcquistoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriNexiDebitAcquisto = getParametriNexiDebitAcquisto;
function getCarteNexiDebitInScadenzaStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_CARTE_IN_SCADENZA_START
    };
}
;
function getCarteNexiDebitInScadenzaSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_CARTE_IN_SCADENZA_SUCCESS,
        payload
    };
}
;
const getCarteNexiDebitInScadenza = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getCarteNexiDebitInScadenzaStart());
    extraArguments.getItem('jwt').then((jwt) => {
        new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).getNexiDebitScadute().then((response) => {
            dispatch(getCarteNexiDebitInScadenzaSuccess(response));
        }).catch(async (error) => {
            dispatch(generalError(await (0, __1.formatError)(error)));
        }).finally(() => {
            dispatch((0, general_1.setLoader)(false));
        });
    });
};
exports.getCarteNexiDebitInScadenza = getCarteNexiDebitInScadenza;
function checkUserNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CHECK_USER_START
    };
}
;
function checkUserNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CHECK_USER_SUCCESS,
        payload
    };
}
;
const checkUserNexiDebitAcquisto = () => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(checkUserNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/check_user_nexi_acquisto.json')).then(response => {
            dispatch(checkUserNexiDebitAcquistoSuccess((0, api_rest_1.CheckUserResponseDtoFromJSON)(response)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).checkUserAcquistoNexiDebit().then((response) => {
                dispatch(checkUserNexiDebitAcquistoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.checkUserNexiDebitAcquisto = checkUserNexiDebitAcquisto;
function getListeAggiuntiveProfessioneNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_LISTE_AGGIUNTIVE_PROFESSIONE_START
    };
}
;
function getListeAggiuntiveProfessioneNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_LISTE_AGGIUNTIVE_PROFESSIONE_SUCCESS,
        payload
    };
}
;
const getListeAggiuntiveProfessioneNexiDebitAcquisto = (codiceProfessione) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getListeAggiuntiveProfessioneNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const request = {
            codiceProfessione
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ProfessioneControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).recuperaDatiProfessioneByCodiceProfessione(request).then((response) => {
                dispatch(getListeAggiuntiveProfessioneNexiDebitAcquistoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getListeAggiuntiveProfessioneNexiDebitAcquisto = getListeAggiuntiveProfessioneNexiDebitAcquisto;
function controlloNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CONTROLLO_START
    };
}
;
function controlloNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CONTROLLO_SUCCESS,
        payload
    };
}
;
const controlloNexiDebitAcquisto = (requestParams) => async (dispatch, getState, extraArguments) => {
    var _a, _b, _c, _d;
    dispatch((0, general_1.setLoader)(true));
    dispatch(controlloNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_nexi_acquisto.json')).then(response => {
            dispatch(controlloNexiDebitAcquistoSuccess((0, api_rest_1.DatiCartaAcquistoDtoFromJSON)(response)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        const nexiDebit = getState().nexiDebit;
        const form = nexiDebit.formAcquisto;
        const request = {
            controlloAcquistoRequestDto: {
                codiceRapporto: form.codiceRapporto.value,
                consensoResponseList: form.consensoResponseList.map(x => x.value),
                personaPoliticamenteEsposta: form.personaPoliticamenteEsposta.value,
                professione: form.professione.value,
                provenienzaFondi: form.provenienzaFondi.value,
                scopoPrevalente: form.scopoPrevalente.value,
                tae: form.tae.value,
                tipoCarta: (_d = (_c = (_b = (_a = nexiDebit.convenzioneRapporto) === null || _a === void 0 ? void 0 : _a.cartaList) === null || _b === void 0 ? void 0 : _b.find(carta => { var _a; return ((_a = carta.carta) === null || _a === void 0 ? void 0 : _a.msgKey) == form.tipoCarta.value; })) === null || _c === void 0 ? void 0 : _c.carta) === null || _d === void 0 ? void 0 : _d.tipo,
                codiceRapportoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.codiceRapportoCoBadged,
                flussoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.flussoCobadge,
                pan: requestParams === null || requestParams === void 0 ? void 0 : requestParams.pan
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).controlloAcquistoNexiDebit(request).then((response) => {
                dispatch(controlloNexiDebitAcquistoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.controlloNexiDebitAcquisto = controlloNexiDebitAcquisto;
function getConvenzioneNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_CONVENZIONE_START
    };
}
;
function getConvenzioneNexiDebitAcquistoSucces(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_GET_CONVENZIONE_SUCCESS,
        payload
    };
}
;
const getConvenzioneNexiDebitAcquisto = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(getConvenzioneNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const request = {
            idRapporto: getState().nexiDebit.formAcquisto.codiceRapporto.value || 0
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).convenzioneRapporto(request).then((response) => {
                dispatch(getConvenzioneNexiDebitAcquistoSucces(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getConvenzioneNexiDebitAcquisto = getConvenzioneNexiDebitAcquisto;
function setNexiDebitAcquistoSetTipoCarta(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_TIPO_CARTA,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetTipoCarta = setNexiDebitAcquistoSetTipoCarta;
;
function setNexiDebitAcquistoSetCodiceRapporto(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_CODICE_RAPPORTO,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetCodiceRapporto = setNexiDebitAcquistoSetCodiceRapporto;
;
function setNexiDebitAcquistoSetProfessione(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_PROFESSIONE,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetProfessione = setNexiDebitAcquistoSetProfessione;
;
function setNexiDebitAcquistoSetTae(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_TAE,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetTae = setNexiDebitAcquistoSetTae;
;
function setNexiDebitAcquistoSetProvenienzaFondi(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_PROVENIENZA_FONDI,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetProvenienzaFondi = setNexiDebitAcquistoSetProvenienzaFondi;
;
function setNexiDebitAcquistoSetPersonaPoliticamenteEsposta(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_PERSONA_POLITICAMENTE_ESPOSTA,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetPersonaPoliticamenteEsposta = setNexiDebitAcquistoSetPersonaPoliticamenteEsposta;
;
function setNexiDebitAcquistoSetScopoPrevalente(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_SCOPO_PREVALENTE,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetScopoPrevalente = setNexiDebitAcquistoSetScopoPrevalente;
;
function setNexiDebitAcquistoSetPresaVisioneDocumenti(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_PRESA_VISIONE_DOCUMENTI,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetPresaVisioneDocumenti = setNexiDebitAcquistoSetPresaVisioneDocumenti;
;
function setNexiDebitAcquistoSetPresaVisioneDocumentiFirma(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_PRESA_VISIONE_DOCUMENTI_FIRMA,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetPresaVisioneDocumentiFirma = setNexiDebitAcquistoSetPresaVisioneDocumentiFirma;
;
function setNexiDebitAcquistoSetConsensoResponseList(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_SET_CONSENSO_RESPONSE_LIST,
        payload: value
    };
}
exports.setNexiDebitAcquistoSetConsensoResponseList = setNexiDebitAcquistoSetConsensoResponseList;
;
function resetControlloNexiDebitAcquisto() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_RESET_CONTROLLO
    };
}
exports.resetControlloNexiDebitAcquisto = resetControlloNexiDebitAcquisto;
;
function resetNexiDebitAcquisto() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_RESET
    };
}
exports.resetNexiDebitAcquisto = resetNexiDebitAcquisto;
;
function resetNexiDebitParametriAcquisto() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_PARAMETRI_ACQUISTO
    };
}
exports.resetNexiDebitParametriAcquisto = resetNexiDebitParametriAcquisto;
;
function verificaCGSNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_VERIFICA_CGS_START
    };
}
;
function verificaCGSNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_VERIFICA_CGS_SUCCESS,
        payload
    };
}
;
const verificaCGSNexiDebitAcquisto = () => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(verificaCGSNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/verifica_CGS.json')).then(response => {
            dispatch(verificaCGSNexiDebitAcquistoSuccess((0, api_rest_1.EsitoVerificaCGSFromJSON)(response)));
            dispatch((0, general_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.FirmaDigitalePrivateControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).verificaCGS().then((response) => {
                dispatch(verificaCGSNexiDebitAcquistoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.verificaCGSNexiDebitAcquisto = verificaCGSNexiDebitAcquisto;
function annullaAcquistoNexiDebitAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ANNULLA_ACQUISTO_START
    };
}
;
function annullaAcquistoNexiDebitAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ANNULLA_ACQUISTO_SUCCESS,
        payload
    };
}
;
const annullaAcquistoNexiDebitAcquisto = (requestParams) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(annullaAcquistoNexiDebitAcquistoStart());
    if (extraArguments.mock) {
        dispatch(annullaAcquistoNexiDebitAcquistoSuccess(true));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const request = {
            annulloPraticaAcquistoDto: {
                codiceRapporto: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.codiceRapporto,
                codiceRapportoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.codiceRapportoCoBadged,
                flussoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.flussoCoBadged,
                pan: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.pan
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).annullaAcquistoNexiDebit(request).then(() => {
                dispatch(annullaAcquistoNexiDebitAcquistoSuccess(true));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.annullaAcquistoNexiDebitAcquisto = annullaAcquistoNexiDebitAcquisto;
function concludiNegativamentePraticaAcquistoStart() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CONCLUDI_NEGATIVAMENTE_PRATICA_ACQUISTO_START
    };
}
;
function concludiNegativamentePraticaAcquistoSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_ACQUISTO_CONCLUDI_NEGATIVAMENTE_PRATICA_ACQUISTO_SUCCESS,
        payload
    };
}
;
const startPanViewScaNexiDebit = (cartaNexiId) => (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(startPanViewScaStartNexiDebit());
    if (extraArguments.mock) {
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const startPinViewSCARequest = {
            startPanViewSCARequestDto: {
                id: cartaNexiId
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .startPanViewSCA(startPinViewSCARequest)
                .then(async (response) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_NEXI_DEBIT', 'GET_PAN_VIEW_SUCCESS_NEXI_DEBIT');
                dispatch(startPanViewScaSuccessNexiDebit(response));
            }).catch(async (error) => {
                extraArguments.sendEventToMatomo('PAN_VIEW_NEXI_DEBIT', `GET_PAN_VIEW_ERROR_NEXI_DEBIT ${error.message}`);
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.startPanViewScaNexiDebit = startPanViewScaNexiDebit;
//END START PAN VIEW SCA
//START GET PAN VIEW
function getPanViewStartNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PAN_VIEW_START
    };
}
;
function getPanViewSuccessNexiDebit(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_GET_PAN_VIEW_SUCCESS,
        payload
    };
}
;
const getPanViewNexiDebit = () => (dispatch, getState, extraArguments) => {
    var _a, _b;
    dispatch((0, general_1.setLoader)(true));
    dispatch(getPanViewStartNexiDebit());
    if (extraArguments.mock) {
        dispatch(getPanViewSuccessNexiDebit({ "content": "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", "contentType": "image/svg+xml" }));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        const nexiDebit = getState().nexiDebit;
        if (!((_a = nexiDebit.startPanViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
            return;
        }
        const getPinViewRequest = {
            txId: (_b = nexiDebit.startPanViewResponse) === null || _b === void 0 ? void 0 : _b.txId
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
                .getPanView(getPinViewRequest)
                .then(async (response) => {
                dispatch(getPanViewSuccessNexiDebit(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, __1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.getPanViewNexiDebit = getPanViewNexiDebit;
//END GET PAN VIEW
function resetPanViewNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_PAN_VIEW
    };
}
exports.resetPanViewNexiDebit = resetPanViewNexiDebit;
;
//START START PAN VIEW SCA
function startPanViewScaStartNexiDebit() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_START_PAN_VIEW__SCA_START
    };
}
;
function startPanViewScaSuccessNexiDebit(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_START_PAN_VIEW__SCA_SUCCESS,
        payload
    };
}
;
//COPY PAN VIEW
function copyPanViewNexiDebitSuccess(payload) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_COPY_PAN_VIEW,
        payload,
    };
}
exports.copyPanViewNexiDebitSuccess = copyPanViewNexiDebitSuccess;
const copyPanViewNexiDebit = () => (dispatch, getState, extraArguments) => {
    var _a, _b, _c;
    dispatch((0, general_1.setLoader)(true));
    const nexiDebit = getState().nexiDebit;
    if (!((_a = nexiDebit.startPanViewResponse) === null || _a === void 0 ? void 0 : _a.txId)) {
        dispatch((0, general_1.setLoader)(false));
        return;
    }
    const getPinViewRequest = {
        body: (_c = (_b = nexiDebit.getPanViewResponse) === null || _b === void 0 ? void 0 : _b.content) !== null && _c !== void 0 ? _c : ''
    };
    extraArguments.getItem("jwt").then((jwt) => {
        new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt))
            .getEncryptedNexiDebitPanView(getPinViewRequest)
            .then(async (response) => {
            dispatch(copyPanViewNexiDebitSuccess(response));
        })
            .catch(async (error) => {
            try {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }
            catch (e) {
                console.log(e);
            }
        })
            .finally(() => {
            dispatch((0, general_1.setLoader)(false));
        });
    });
};
exports.copyPanViewNexiDebit = copyPanViewNexiDebit;
const concludiNegativamentePraticaAcquisto = (requestParams) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_1.setLoader)(true));
    dispatch(concludiNegativamentePraticaAcquistoStart());
    if (extraArguments.mock) {
        dispatch(concludiNegativamentePraticaAcquistoSuccess(true));
        dispatch((0, general_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const request = {
                annulloPraticaAcquistoDto: {
                    codiceRapporto: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.codiceRapporto,
                    codiceRapportoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.codiceRapportoCoBadged,
                    flussoCoBadged: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.flussoCoBadged,
                    pan: requestParams === null || requestParams === void 0 ? void 0 : requestParams.annulloPraticaAcquistoDto.pan
                }
            };
            new api_rest_1.NexiDebitControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).concludiNegativamenteAcquistoNexiDebit(request).then(() => {
                dispatch(concludiNegativamentePraticaAcquistoSuccess(true));
            }).catch(async (error) => {
                dispatch(generalError(await (0, __1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_1.setLoader)(false));
            });
        });
    }
};
exports.concludiNegativamentePraticaAcquisto = concludiNegativamentePraticaAcquisto;
function setInizioFlussoCarteInScadenza(value) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_SET_INIZIO_FLUSSO_CARTE_IN_SCADENZA,
        payload: value
    };
}
exports.setInizioFlussoCarteInScadenza = setInizioFlussoCarteInScadenza;
function setCobadgeDaRinnovare(cobadge) {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_SET_COBADGE_DA_RINNOVARE,
        payload: cobadge
    };
}
exports.setCobadgeDaRinnovare = setCobadgeDaRinnovare;
function resetRinnovoCobadge() {
    return {
        type: nexiDebit_types_1.ENexiDebitActionTypes.NEXI_DEBIT_RESET_RINNOVO_COBADGE
    };
}
exports.resetRinnovoCobadge = resetRinnovoCobadge;
